import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { UsePathResetHook } from 'routing/utils/path-reset-hook.js';

export enum Pages {
  ROOT = '/',
  HOME = '/national',
}

/** Rewrites '/' to '/national' */
const normalisedUrl = (href: string) => {
  if (href === `${Pages.ROOT}`) {
    return Pages.HOME;
  }
  return href;
};

/**
 * As `/` is alias for `/national` we manage this here so that any requests to the api on the home page are for `/national`
 * This is used by react-router for getting data from the api
 */
export const useAPIFetchPath = () => {
  const rawPath = useLocation().pathname;
  const [path, setNormalisedPath] = useState(normalisedUrl(rawPath));
  UsePathResetHook({ path });

  useEffect(() => {
    const normalisedPath = normalisedUrl(rawPath);
    setNormalisedPath(normalisedPath);
  }, [rawPath]);

  return { path };
};
